import { useQueryParam } from '~/adapters/react-router/useQueryParam';

export const useAuth0ScreenHint = () => {
    const screenHint = useQueryParam('auth0_screen_hint');

    return {
        screenHint,
    };
};
